// :cow: Cosmose CONFIDENTIAL :iso:
import { createAction, props } from '@ngrx/store';
import { VideoCreatorListResponse } from '@par/app/core/model/dictionaries.response';

export const getVideoCreatorListRequested = createAction('[SELECT VIDEO CREATOR] Get Video Creator List Requested');
export const getVideoCreatorListSucceeded = createAction('[SELECT VIDEO CREATOR] Get Video Creator List Succeeded', props<{
  response: VideoCreatorListResponse
}>());
export const getVideoCreatorListFailed = createAction('[SELECT VIDEO CREATOR] Get Video Creator List Failed');
